/** HerSkin 在登录页和应用顶栏共用的产品说明，避免品牌文案在入口组件中漂移。 */
export function ProductSubtitle({ className = "" }: { className?: string }) {
  return <span className={`herskin-signature ${className}`.trim()}>Web Interface for Hermes</span>;
}
